













import { Component, Vue, Watch } from 'vue-property-decorator';

import CloseIcon from '@/components/icons/Close.vue';

import eventBus from '@/utils/eventBus';

import BusinessService from '@/api/BusinessService';
import FeedbackService from '@/api/FeedbackService';

import { ETutorial } from '@/models/tutorial';

import Review from '../Review/Review.vue';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    CloseIcon,
    Review
  }
})
export default class FeedbackModal extends Vue {
  serviceFeedback = new FeedbackService();
  serviceBusiness = new BusinessService();
  hasSendFeedback = false;
  success = false;

  get tPrefix() {
    return 'common.components.feedback';
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get isImpersonated() {
    return this.$store.getters['manager/isImpersonated'];
  }

  onSuccess() {
    this.success = true;
  }

  onSuccessClick() {
    segmentIo.track('Clicked Feedback Platform Success Close');
    this.onClose(false);
  }

  onClose(track = true) {
    if (track) segmentIo.track('Clicked Feedback Platform Close');

    if (this.business.showPlatformFeedback)
      setTimeout(() => {
        eventBus.$emit('openNotificationArrow', {
          text: this.$t(`${this.tPrefix}.notification`),
          element: document.querySelector(
            '.topbar-business-choose .menu-select'
          )
        });
      }, 250);

    eventBus.$emit('closeModal');
  }

  sendFeedback({ rating, comment, provider }: any) {
    segmentIo.track('Clicked Feedback Platform Submit', { rating, provider });
    return this.serviceFeedback.sendFeedback({
      rating,
      comment,
      provider
    });
  }

  @Watch('business')
  changedBusinessInfo() {
    if (!this.success) this.hasSendFeedback = this.business.hasSendFeedback;
  }

  async created() {
    segmentIo.modal('Feedback Platform');
    this.hasSendFeedback = this.business.hasSendFeedback;
    if (this.business.showPlatformFeedback && !this.isImpersonated) {
      await this.serviceBusiness.updateBusinessFlagTutorial({
        state: false,
        flag: ETutorial.SHOW_PLATFORM_FEEDBACK
      });
      const business = {
        ...this.business,
        showPlatformFeedback: false
      };
      eventBus.$emit('setBusinessInfo', business);
      this.$store.dispatch('business/SET_BUSINESS_INFO', business);
    }
  }
}
